import React from 'react';

const PrivacyInformation = () => {
    const contents = `${window.MPS_CompanyInquiryMeta.PrivacyInformationPolicy}`;
    return (
        <div dangerouslySetInnerHTML={{ __html: contents }} />
    );
};
export default PrivacyInformation;


// WEBPACK FOOTER //
// ./mypage/js/MPS_CompanyInquiry/components/policy.jsx